import type { ApplePayJS } from '../../../../../types/apple-pay'
import type {
  PaymentRequestContactAddress,
  PaymentRequestItem,
  PaymentRequestPaymentResponse,
  PaymentRequestShippingOption,
} from '../../../types/PaymentRequest'

export const mapItemToApplePayLineItem = (
  item: PaymentRequestItem,
): ApplePayJS.ApplePayLineItem => ({
  label: item.label,
  amount: item.amount.amount,
  type: item.pending ? 'pending' : 'final',
})

const sortShippingOptionsWithSelectedFirst = (
  options: PaymentRequestShippingOption[],
): PaymentRequestShippingOption[] =>
  [...options].sort((a, b) => Number(b.selected) - Number(a.selected))

export const mapShippingOptionToApplePayMethod = (
  option: PaymentRequestShippingOption,
): ApplePayJS.ApplePayShippingMethod => ({
  label: option.label,
  detail: '',
  amount: option.amount.amount,
  identifier: option.id,
})

export const mapShippingOptionsToApplePayMethods = (
  options: PaymentRequestShippingOption[],
): ApplePayJS.ApplePayShippingMethod[] =>
  sortShippingOptionsWithSelectedFirst(options).map(
    mapShippingOptionToApplePayMethod,
  )

export const mapAddressToApplePayContact = (
  address: PaymentRequestContactAddress,
): ApplePayJS.ApplePayPaymentContact => ({
  givenName: address.firstName,
  familyName: address.lastName,
  addressLines: address.addressLine,
  locality: address.city,
  postalCode: address.postalCode,
  administrativeArea: address.region,
  countryCode: address.country,
  phoneNumber: address.phone,
  subLocality: address.dependentLocality,
})

export const mapApplePayContactToAddress = (
  contact: ApplePayJS.ApplePayPaymentContact,
): PaymentRequestContactAddress => ({
  firstName: contact.givenName ?? '',
  lastName: contact.familyName ?? '',
  addressLine: contact.addressLines ?? [],
  city: contact.locality ?? '',
  postalCode: contact.postalCode ?? '',
  region: contact.administrativeArea ?? '',
  country: contact.countryCode ?? '',
  phone: contact.phoneNumber ?? '',
  organization: '',
  dependentLocality: contact.subLocality ?? '',
  sortingCode: '',
})

export const mapApplePayPaymentToPaymentResponse = (
  payment: ApplePayJS.ApplePayPayment,
  shippingMethodId?: string,
): PaymentRequestPaymentResponse => ({
  payerFirstName: payment.shippingContact?.givenName,
  payerLastName: payment.shippingContact?.familyName,
  payerEmail: payment.shippingContact?.emailAddress,
  payerPhone: payment.shippingContact?.phoneNumber,
  billingAddress: payment.billingContact
    ? mapApplePayContactToAddress(payment.billingContact)
    : undefined,
  shippingAddress: payment.shippingContact
    ? mapApplePayContactToAddress(payment.shippingContact)
    : undefined,
  shippingOption: shippingMethodId,
})
